export const formatDuration = (seconds: number = 0): string => {
    const date = new Date(seconds * 1000);
    // const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const formattedTime = `${minutes
      .toString()
      .padStart(2, '0')}:${date.getUTCSeconds().toString().padStart(2, '0')}`;
    return formattedTime;
  };
